/* eslint-disable no-param-reassign */
import React from "react";
import { CURRENCY } from "constants/CustomConstants";

const index = ({ name, time, price }) => {
  let timer = "mins";

  if (time >= 60) {
    time /= 60;
    timer = "hour";
  }

  return (
    <div className="business-text d-flex flex-row justify-content-between m-3">
      <div className="text-left">
        <h5>
          {name} - {time} {timer}
        </h5>
      </div>
      <div className="text-right">
        <h5>
          {/* {price ?  : null} */}
          {price || null}
        </h5>
      </div>
    </div>
  );
};

export default index;



// WEBPACK FOOTER //
// ./components/ServiceBottom/ServicesContainer/Services/index.js